import { render, staticRenderFns } from "./AllInputFields.vue?vue&type=template&id=38747dad&lang=pug&"
import script from "./AllInputFields.vue?vue&type=script&lang=js&"
export * from "./AllInputFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports